import {
  addClaim,
  resetError,
  resetOnSearch,
  setClaims,
  setIsClaimLoading,
} from 'core/store/claimsV2Slice';
import { useDispatch } from 'react-redux';

import { useUserMetaData } from 'hooks/useUserMetaData';
import { claimDetectionRequest } from 'utils/API/claimDetection';
import { useCheckClaim } from './useCheckClaim';
import { useGenerate } from './useGenerate';

import useScrollToClaims from './useScrollToClaim';

export const useCheckText = () => {
  const dispatch = useDispatch();
  const { liteSubscription, proSubscription } = useUserMetaData();

  const checkClaim = useCheckClaim();
  const { handleScrollToClaim } = useScrollToClaims();
  const getGeneratedClaims = useGenerate();

  const MIN_TEXT_LENGTH = 10;
  const MAX_CLAIM_LENGTH = 100;

  const checkText = (text: string) => {
    if (text.length < MIN_TEXT_LENGTH) {
      console.log('text too short'); // TODO: replace with warning for the user
    } else {
      dispatch(resetOnSearch());
      dispatch(setIsClaimLoading(true));
      dispatch(resetError());
      if (text.length <= MAX_CLAIM_LENGTH) {
        dispatch(addClaim({ claim: text }));
        checkClaim(text);
      } else {
        claimDetectionRequest(text)
          .then((response) => {
            dispatch(setClaims(response.data.detectedClaims));
            // Check all claims for lite/pro subscriptions, only first claim for no subscription
            if (liteSubscription || proSubscription) {
              response.data.detectedClaims.forEach((claim) => {
                checkClaim(claim.claim);
                getGeneratedClaims(claim.claim);
              });
            } else {
              checkClaim(response.data.detectedClaims[0].claim);
            }
          })
          .finally(() => {
            setTimeout(() => {
              dispatch(setIsClaimLoading(false));
              handleScrollToClaim();
            }, 1000);
          });
      }
    }
  };

  return checkText;
};
